import { useAllocation } from '../useAllocation';
import { supFixTwentyVsThirtyExp, variantExp } from '../../experiments/frontDoorOffer';
export const useSupFixOffer = (skip = false) => {
  const {
    data: allocationData,
    loading
  } = useAllocation(skip ? [] : [supFixTwentyVsThirtyExp, variantExp]);
  const isThirtyDollarTreatment = allocationData?.visitor?.configParams?.find(p => p.name === supFixTwentyVsThirtyExp.name)?.value === 'thirty';
  const slimBannerVariant = allocationData?.visitor?.configParams?.find(p => p.name === variantExp.name)?.value || variantExp.fallbackValue;
  return {
    isThirtyDollarTreatment,
    offerAmount: isThirtyDollarTreatment ? 30 : 20,
    slimBannerVariant,
    loading
  };
};